import { IDeleteEntregaProdutoServicoUseCase } from "../../../presentation/useCases/read/delete_entrega_produto_servico_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteEntregaProdutoServicoUseCase
 */

export class DeleteEntregaProdutoServicoUseCase implements IDeleteEntregaProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteEntregaProdutoServico(
    idOrdemCompra: number,
    idProdutoServicoEntregue: number,
  ): Promise<void> {
    await this.repository.deleteEntregaProdutoServico(idOrdemCompra, idProdutoServicoEntregue);
  }
}
